import React from "react";
import { string, number, arrayOf, object } from "prop-types";

const SequenceLineContainer = ({
	scrollRef,
	overviewRef,
	filename,
	relativePath,
	lineCount,
	estLineHeight,
	lastLineHeights,
}) => (
	<div
		id="seq1"
		ref={scrollRef}
		className="sg-visualization"
		data-id={filename}
		data-filename={filename}
		data-relative-path={relativePath}
		data-line-count={lineCount}
		data-est-line-height={estLineHeight}
		data-last-line-heights={`[${lastLineHeights.join(",")}]`}
		data-show-enzymes="true"
		data-show-features="true"
		data-show-primers="true"
		data-show-translations="false"
		style={{
			height: "820px",
			width: "100%",
			borderStyle: "solid",
			borderWidth: "1px",
			overflowY: "scroll",
		}}
	>
		<div className="viewport">
			<div className="overview" ref={overviewRef} />
			<div className="tips" />
		</div>
	</div>
);

SequenceLineContainer.propTypes = {
	scrollRef: object, // eslint-disable-line react/forbid-prop-types
	overviewRef: object, // eslint-disable-line react/forbid-prop-types
	filename: string,
	relativePath: string,
	lineCount: number,
	estLineHeight: number,
	lastLineHeights: arrayOf(number),
};

export default SequenceLineContainer;
